import React from 'react';

import { WaitlistLogo } from '../../waiting-list/components/WaitlistLayout';
import '../styles/onboarding.css';

const STAR_SRC = '/images/onboarding/star-yellow.svg';

/**
 * Right-hand artwork per onboarding step (Figma MVP-DESIGNES 9224:4381 ..
 * 9226:4449). The PNG strips are stored pre-rotated so that `object-fit: cover`
 * reproduces the Figma crop without CSS transforms.
 */
export const ONBOARDING_ARTWORK = {
    about: { src: '/images/onboarding/gradient-about.png' },
    workspace: { src: '/images/onboarding/gradient-workspace.png' },
    improve: { src: '/images/onboarding/gradient-improve.png' },
    audience: { src: '/images/onboarding/gradient-audience.png' },
};

/**
 * Page chrome for the creator onboarding wizard (/create-workspace).
 *
 * `variant="split"` (default) is the 772px left column (logo, centred 501px
 * white card, action row under the card) next to a full-height gradient panel
 * with the yellow star; `artwork` picks the gradient for the current step.
 * `variant="wide"` (terms step, Figma 9236:2369) drops the panel and widens the
 * card to 760px.
 *
 * `footer` renders in the right-aligned action row directly under the card
 * (the "Next" / "Continue" primary button); `progress` is the step indicator
 * pinned to the bottom of the column (Figma 9251:5312), below the centred
 * card + action block.
 */
export default function OnboardingLayout({ variant = 'split', artwork = 'about', footer = null, progress = null, children }) {
    const art = ONBOARDING_ARTWORK[artwork] || ONBOARDING_ARTWORK.about;
    return (
        <div className={`onboarding-page onboarding-page-${variant}`}>
            <div className="onboarding-column">
                <WaitlistLogo size="small" />
                <div className="onboarding-content">
                    <div className="onboarding-main">
                        <main className="onboarding-card fs-unmask">{children}</main>
                        {footer ? <div className="onboarding-actions">{footer}</div> : null}
                    </div>
                    {progress}
                </div>
            </div>
            {variant === 'split' ? (
                <div className={`onboarding-art onboarding-art-${artwork}`} aria-hidden="true">
                    <img className="onboarding-art-gradient" src={art.src} alt="" />
                    <div className="onboarding-art-star">
                        <img src={STAR_SRC} alt="" />
                    </div>
                </div>
            ) : null}
        </div>
    );
}
